import React, { useMemo } from "react";
import { isMobile } from "react-device-detect";
import { CircularProgress, Typography } from "@mui/material";

import { H1 } from "../../../components/headings";
import { ACH, APPLE, GOOGLE } from "../../../constants";
import { addTransactionFee } from "../../../helpers";
import { PaymentRequestForm } from './paymentOptionComponents/GoogleApplePay';
import { MixPanelTrackedLink, StripeWrapper } from '../../../components';
import { useSelector } from "react-redux";

function DonateNowButton({ googleApplePayReference, state, handleClick }) {
    const showSubmitLoader = useSelector(state => state.checkoutProcessing);

    const donateNowButtonClass = isMobile ? "justify-content-center" : "justify-content-end"

    const getTotalDonation = () => {
        return state.coverTheTransactionFee && state.donationAmount && state.selectedPaymentMethod ?
            addTransactionFee(state.donationAmount, state.transactionFeePercentage)
            : state.donationAmount > 0 ? state.donationAmount?.toString() : 0
    }
    return <>
        <div className="donatebtn">
            <div className="left">
                <div className={`d-flex ${donateNowButtonClass}`}>
                    {state.selectedPaymentMethod == GOOGLE || state.selectedPaymentMethod == APPLE ?
                        <div className="stripe-div" id="stripe-button-container">
                            <div>
                                <div className="form-group" id="payment-request-button">
                                    <StripeWrapper key={state.stripePublicKey} public_key={state.stripePublicKey}>
                                        <PaymentRequestForm
                                            key={state.donationAmount}
                                            ref={googleApplePayReference}
                                            donation_amount={state.donationAmount | 0}
                                            currency_code={state.selectedCountry.currency.code.toLowerCase()}
                                            country_code={state.selectedCountry.code}
                                            handlePayment={handleClick}
                                        />
                                    </StripeWrapper>
                                </div>
                            </div>
                        </div>
                        : <MixPanelTrackedLink
                            type="button"
                            label="Give Now"
                            context={"Checkout Form Submission"}
                            variant="contained"
                            onClick={handleClick}
                            disabled={showSubmitLoader}
                        >
                            {(showSubmitLoader ? <CircularProgress sx={{ color: 'white' }} size={25} /> : 'Give Now')}
                        </MixPanelTrackedLink>
                    }
                </div>
            </div>
            <div className="right">
                <Typography>Amount:</Typography>
                <H1 content={state.selectedCountry.currency.symbol + " " + getTotalDonation()} smallText={state.selectedCountry.currency.code} />
            </div>
        </div>
        {state.selectedPaymentMethod == ACH ? <Typography variant="small" align="center" sx={{ mt: "5px !important" }}>
            By clicking 'Give Now' you agree to authorize payments pursuant to <MixPanelTrackedLink type="link" href="#">
                these terms.</MixPanelTrackedLink>
        </Typography> : null}
    </>
}

export default function ({ googleApplePayReference, handleClick, showSubmitLoader }) {
    const state = useSelector(state => state.donationCheckout);

    return useMemo(() => {
        return <DonateNowButton
            googleApplePayReference={googleApplePayReference}
            state={state}
            handleClick={handleClick}
            showSubmitLoader={showSubmitLoader}
        />
    }, [
        googleApplePayReference,
        state.donationAmount,
        state.coverTheTransactionFee,
        state.selectedPaymentMethod,
        state.transactionFeePercentage,
        state.stripePublicKey,
        state.selectedCountry,
        showSubmitLoader
    ])
}